<template>
  <div class="machine-model-edit-form flex flex-col">
    <div class="primary-lighten-1 flex w-full flex-col gap-y-2 rounded-md p-2">
      <label>
        <span class="sr-only block text-sm">Machinenaam</span>
        <InputText
          v-model="machine.name"
          placehoder="Machinenaam"
          ref="inputName"
          @blur="v$.name.$touch()"
          :errors="v$.name.$errors"
        />
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
import InputText from "@/components/inputs/InputText.vue"
import { requiredValidator } from "@/helper/validation/validators"
import { useFormConfigurator } from "@/composables/form/form-configurator"
import { Machine } from "@/models/machine.model"
import { inject, onMounted, ref } from "vue"
import { MachineController } from "@/controllers/model-controllers/machine-controller"
import { upperFirst } from "lodash-es"
import { formFocusHack } from "@/helper/form-helper"

const rules = {
  name: { requiredValidator } // todo not exist
}

const controller: MachineController = inject("machineController")!

const { model: machine, initialText, v$ } = useFormConfigurator<Machine>({ controller, rules })

const inputName = ref()
onMounted(() => {
  if (initialText) {
    machine.value.name = upperFirst(initialText)
  }
  formFocusHack(inputName, machine, "name")
})
</script>

<style scoped></style>
